// extracted by mini-css-extract-plugin
export default {"pagehome":"homecontent_pagehome__wIDMD","homecontent":"homecontent_homecontent__1W1Ah","teaserimage":"homecontent_teaserimage__8+kwn"};